import { useEffect } from "react";
import { numeroALetras, redondearDecimales } from "../../../../utils/utils_number";

import { resumenFEXSchema, facturaFEXchema } from "./schemas/zod/fex.schema";

const useFEX_JSON = (factura, setFactura) => {
  useEffect(() => {
    setFactura((prev) => {
      const { extension, ...rest } = prev;
      return {
        ...rest,
        identificacion: {
          ...rest.identificacion,
          version: 1,
        },
        otrosDocumentos: null,
        resumen: {
          totalGravada: 0,
          descuento: 0,
          porcentajeDescuento: 0,
          totalDescu: 0,
          seguro: 0,
          flete: 0,
          montoTotalOperacion: 0,
          totalNoGravado: 0,
          totalPagar: 0,
          totalLetras: "",
          condicionOperacion: 2,
          pagos: [],
          codIncoterms: "",
          descIncoterms: "",
          numPagoElectronico: null,
          observaciones: null,
        },
      };
    });
  }, []);

  const itemBase = {
    numItem: 1,
    cantidad: "",
    codigo: null,
    uniMedida: 59,
    descripcion: "",
    precioUni: "",
    montoDescu: 0.0,
    ventaGravada: 0,
    tributos: ["C3"],
    noGravado: 0.0,
  };

  const formatearItem = (formData, _, comprobanteRelacionado, index) => {
    const cantidad = redondearDecimales(parseFloat(formData.cantidad)) || 0;
    const precioUnitario = redondearDecimales(parseFloat(formData.precioUni)) || 0;
    const montoTotal = redondearDecimales(cantidad * precioUnitario);

    let item = {
      ...formData,
      numItem: index,
      cantidad,
      precioUni: precioUnitario,
      ventaGravada: montoTotal,
      tributos: ["C3"],
    };

    if (comprobanteRelacionado) {
      item.numeroDocumento = comprobanteRelacionado.codigoGeneracion || null;
    }

    return item;
  };

  const setEmisor = (emisorBase, _) => {
    const emisorLimpio = {
      ...emisorBase,
      tipoItemExpor: 2, // REVISAR CAT-011
      recintoFiscal: null,
      regimen: null,
    };
    return emisorLimpio;
  };

  const setReceptor = (receptorBase, receptorRaw, tipoDocumento) => {
    const { nit, nrc, codActividad, descActividad, direccion, ...rest } = receptorBase;
    const receptorLimpio = {
      ...rest,
      numDocumento: receptorRaw.numDocumento, // Quitamos guiones del NIT
      descActividad: descActividad, //"Exportacion", // ver como putas setear esto
      codPais: "SV",
      nombrePais: "El Salvador",
      complemento: direccion.complemento || "",
      tipoPersona: 2, // 1: Natural, 2: Juridica
      tipoDocumento,
    };

    return receptorLimpio;
  };

  // Función para asignar resumen de totales
  const setResumen = (resumen) => {
    const totalGravada = redondearDecimales(resumen.totalGravada, 2);
    const resumenValidado = resumenFEXSchema.parse({
      ...resumen,
      totalGravada: totalGravada,
      montoTotalOperacion: totalGravada,
      totalPagar: totalGravada,
      totalLetras: numeroALetras(totalGravada),
      condicionOperacion: resumen.formaPago?.value || 2,
      pagos:
        resumen.formaPago?.value === 1
          ? null
          : [
              {
                codigo: "01",
                montoPago: totalGravada,
                referencia: null,
                plazo: "01",
                periodo: parseInt(resumen.formaPago.diascredito),
              },
            ],
      codIncoterms: null, // CAT-031 - Incoterms, debe setearse cuando tipoItemExpor es 1 o 3 (Exportación)
      descIncoterms: null, // CAT-031 - Descripción de Incoterms
      numPagoElectronico: null,
      observaciones: "", //"Exportación libre de impuestos",
    });

    setFactura((prev) => ({
      ...prev,
      resumen: resumenValidado,
    }));
  };

  const buildJson = () => {
    return facturaFEXchema.parse(factura); // ← limpia, valida y devuelve el JSON final
  };

  return {
    itemBase,
    formatearItem,
    setReceptor,
    setResumen,
    setEmisor,
    buildJson,
  };
};

export default useFEX_JSON;
